import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import api from "../../../api/axiosInstance";

const HeroSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadHero = async () => {
      try {
        const res = await api.get('/api/about');
        setData(res.data);
      } catch (err) {
        console.error('Failed to load hero section', err);
      } finally {
        setLoading(false);
      }
    };

    loadHero();
  }, []);

  if (loading) {
    return (
      <section className="py-16 flex justify-center">
        <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </section>
    );
  }

  if (!data) return null;

  const { badgeText, heading, description, heroImage, statsRef } = data;

  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-12 md:py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          
          {/* LEFT */}
          <div className="space-y-4 md:space-y-6 lg:space-y-8">
            <div className="inline-flex items-center space-x-2 bg-primary/10 px-4 py-2 rounded-full">
              <Icon name="Award" size={20} color="var(--color-primary)" />
              <span className="text-sm md:text-base font-medium text-primary">
                {badgeText}
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground leading-tight">
              {heading}
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-muted-foreground leading-relaxed max-reading-width">
              {description}
            </p>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <button className="px-6 md:px-8 py-3 md:py-4 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-base focus-ring flex items-center justify-center space-x-2">
                <span>Start Learning</span>
                <Icon name="ArrowRight" size={20} />
              </button>

              <button className="px-6 md:px-8 py-3 md:py-4 bg-card text-foreground border-2 border-border rounded-lg font-medium hover:bg-muted transition-base focus-ring flex items-center justify-center space-x-2">
                <Icon name="PlayCircle" size={20} color="var(--color-primary)" />
                <span>Watch Demo</span>
              </button>
            </div>
          </div>

          {/* RIGHT */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <Image
                src={heroImage}
                alt="Hero image"
                className="w-full h-64 md:h-80 lg:h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent" />
            </div>

            {statsRef && (
              <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-card p-4 md:p-6 rounded-xl shadow-lg border border-border">
                <div className="flex items-center space-x-3 md:space-x-4">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-success/10 rounded-full flex items-center justify-center">
                    <Icon name="TrendingUp" size={24} color="var(--color-success)" />
                  </div>
                  <div>
                    <p className="text-2xl md:text-3xl font-bold text-foreground">
                      {statsRef.successRate}%
                    </p>
                    <p className="text-xs md:text-sm text-muted-foreground">
                      Success Rate
                    </p>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
